import { sidebarCssClasses } from "@/shared/classes";

const MENU_STORAGE_KEY = "viewer-menu-show";

export function getAppQuery(route) {
  const fromSearch = {};
  if (typeof window !== "undefined" && window.location.search) {
    window.location.search
      .replace(/^\?/, "")
      .split("&")
      .forEach((pair) => {
        if (!pair) return;
        const parts = pair.split("=");
        const key = decodeURIComponent(parts[0] || "");
        const value = decodeURIComponent(parts.slice(1).join("=") || "");
        if (key) fromSearch[key] = value;
      });
  }
  return Object.assign({}, fromSearch, (route && route.query) || {});
}

export function parseBoolParam(value) {
  if (value === undefined || value === null || value === "") return null;
  const v = String(value).toLowerCase();
  if (["false", "0", "no", "off"].indexOf(v) !== -1) return false;
  if (["true", "1", "yes", "on"].indexOf(v) !== -1) return true;
  return null;
}

export function isMenuShown(route) {
  const fromQuery = parseBoolParam(getAppQuery(route).menuShow);
  if (fromQuery !== null) {
    try {
      sessionStorage.setItem(MENU_STORAGE_KEY, fromQuery ? "true" : "false");
    } catch (e) {
      /* ignore */
    }
    return fromQuery;
  }
  try {
    const stored = sessionStorage.getItem(MENU_STORAGE_KEY);
    if (stored === "false") return false;
    if (stored === "true") return true;
  } catch (e) {
    /* ignore */
  }
  return true;
}

export function applyMenuVisibility(route) {
  const show = isMenuShown(route);
  const body = document.body;
  if (!show) {
    body.classList.add("viewer-menu-hidden");
    sidebarCssClasses.forEach((c) => body.classList.remove(c));
  } else {
    const wasHidden = body.classList.contains("viewer-menu-hidden");
    body.classList.remove("viewer-menu-hidden");
    if (wasHidden) body.classList.add("sidebar-lg-show");
  }
  return show;
}

export function revealMenuManually(router) {
  try {
    sessionStorage.setItem(MENU_STORAGE_KEY, "true");
  } catch (e) {
    /* ignore */
  }

  const body = document.body;
  body.classList.remove("viewer-menu-hidden");
  body.classList.add("sidebar-lg-show");

  const route = router.currentRoute;
  if (route.query.menuShow !== undefined) {
    const query = Object.assign({}, route.query);
    delete query.menuShow;
    router.replace({ path: route.path, query: query, hash: route.hash });
  }

  if (
    typeof window !== "undefined" &&
    window.location.search &&
    /(?:^|[?&])menuShow=/.test(window.location.search)
  ) {
    const params = window.location.search
      .replace(/^\?/, "")
      .split("&")
      .filter((pair) => {
        const key = decodeURIComponent(pair.split("=")[0] || "");
        return key !== "menuShow";
      });
    const newSearch = params.length ? "?" + params.join("&") : "";
    window.history.replaceState(
      window.history.state,
      "",
      window.location.pathname + newSearch + window.location.hash
    );
  }
}
